import HrvStats from "../../../calendar/body-composition/components/HrvStats";
import SleepStats from "../../../calendar/body-composition/components/SleepStats";
import StepsStats from "../../../calendar/body-composition/components/StepsStats";

const SummaryDailyStats = ({
  dailyStats,
  athlete,
  organizationCoachParam,
  date,
}) => {
  const hasSleepData = dailyStats.some((data) => data.sleep);
  const hasHrvData = dailyStats.some((data) => data.hrv);
  const hasStepsData = dailyStats.some((data) => data.steps);
  return (
    <section className="summary-personal-stats">
      {hasStepsData && (
        <StepsStats
          data={dailyStats}
          date={date}
          athlete={athlete?._id ?? athlete}
          previousWeek={[]}
          organizationCoachParam={organizationCoachParam}
        />
      )}
      {hasSleepData && (
        <SleepStats
          data={dailyStats}
          date={date}
          athlete={athlete?._id ?? athlete}
          previousWeek={[]}
          organizationCoachParam={organizationCoachParam}
        />
      )}
      {hasHrvData && (
        <HrvStats
          data={dailyStats}
          date={date}
          athlete={athlete?._id ?? athlete}
          organizationCoachParam={organizationCoachParam}
          previousWeek={[]}
        />
      )}
    </section>
  );
};

export default SummaryDailyStats;
